import { ADD_CART, CLEAR_CART, COUPON, DELETE_CART, EDIT_QTY_CART } from "../types/checkout";

const initialState = {
  cart: [],
  coupon: null,
};

const checkoutReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_CART:
      let alreadyInCart = false;
      state.cart.forEach((item) => {
        if (item.id === payload.id) {
          alreadyInCart = true;
        }
      });
      if (alreadyInCart) {
        return { ...state };
      } else {
        return { ...state, cart: [...state.cart, payload] };
      }
    case EDIT_QTY_CART:
      const cartCopy = JSON.parse(JSON.stringify(state.cart));
      cartCopy.forEach((el) => {
        if (el.id === payload.id) {
          el.qty = payload.qty;
        }
      });
      return { ...state, cart: cartCopy };
    case DELETE_CART:
      const filteredCart = state.cart.filter((item) => item.id !== payload);
      return { ...state, cart: filteredCart };
    case CLEAR_CART:
      return { ...state, cart: [] };
    case COUPON:
      return { ...state, coupon: payload };
    default:
      return state;
  }
};

export default checkoutReducer;
